import { ServiceSettingsState } from '../types';

export const serviceSettingsSelector = (state: { serviceSettings: ServiceSettingsState }) => state.serviceSettings;
